// frontend/src/components/landing/ResearchCard.jsx
import { SITE } from "../../config";
import Button from "../common/Button";
import CopyButton from "../common/CopyButton";
import { ArrowUpRightIcon } from "../common/Icon";
import "./ResearchCard.css";

const BIBTEX = `@misc{sankar2026asking,
  title         = {${SITE.paper.title}},
  author        = {B. Sankar and Pawni Yadav and Srinidhi Ranjini Girish and Amogh A. S},
  year          = {2026},
  eprint        = {${SITE.paper.arxivId}},
  archivePrefix = {arXiv}
}`;

/** The research paper behind PAWNI. */
export default function ResearchCard({ paper = SITE.paper }) {
  return (
    <section id="research" className="research section" aria-labelledby="research-title">
      <div className="container">
        <article className="research__card">
          <div className="research__side">
            <p className="eyebrow">Research</p>
            <span className="research__id mono">arXiv:{paper.arxivId}</span>
          </div>

          <div className="research__main">
            <h2 id="research-title" className="research__title">
              {paper.title}
            </h2>
            <p className="research__authors">{paper.authors.join(", ")}</p>
            <p className="research__summary">
              The paper describes the system you can use here: a conversational, multi-agent approach to turning
              an under-specified request into a complete prompt by asking the right questions first.
            </p>
            <div className="research__actions">
              <Button
                variant="secondary"
                href={paper.url}
                target="_blank"
                rel="noopener noreferrer"
                iconRight={<ArrowUpRightIcon size={16} />}
              >
                Read on arXiv
              </Button>
              <CopyButton text={BIBTEX} variant="text" size="md" label="Copy BibTeX" copiedLabel="BibTeX copied" />
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
